import Cookies from "js-cookie";

export function getCurrentUser() {
  const c = Cookies.get("accounts-profile")
  if (typeof c !== 'undefined') {
    return JSON.parse(decodeURI(c));
  }
  return null;
}
